import React from 'react';
import { FormControl, Chip, Box } from '@mui/material';
import { Typography700 } from 'views/rebranded-module/common/components';

import StyledRadioGroup from 'views/rebranded-module/common/components/UI/RadioGroupFilterV2/RadioGroupFilterV2.styles';
import { FILTER_TYPE } from 'views/locations-module/LocationsView/utils/constants';
import { RiCircleLine, RiCheckboxCircleFill } from 'react-icons/ri';
import { useSelector } from 'react-redux';

const RadioGroupFilterV2 = ({ filter, handleClick, cmsContent }) => {
  const showMembershipPromotion = useSelector(
    (state) => state.globalData.showMembership,
  );

  const filterOptions = [
    {
      value: FILTER_TYPE.ALL_LOCATIONS,
      label: cmsContent.allLocations,
      mobileTitle: cmsContent.locations,
      showMobileTitle: true,
    },
    {
      value: FILTER_TYPE.US,
      label: cmsContent.us,
    },
    {
      value: FILTER_TYPE.INTERNATIONAL,
      label: cmsContent.international,
    },
  ];

  if (showMembershipPromotion) {
    filterOptions.push({
      value: FILTER_TYPE.CLUB,
      label: cmsContent.clubEaglerider,
      mobileTitle: cmsContent.clubEaglerider,
      showMobileTitle: true,
    });
  }
  return (
    <StyledRadioGroup row className="RadioGroupFilter">
      {filterOptions.map((option) => (
        <React.Fragment key={option.value}>
          {option.showMobileTitle && (
            <Box mt={4} className="showMOBILE">
              <Typography700
                className="RGFOverlayTitles"
                variant="h6"
                component="p">
                {option.mobileTitle}
              </Typography700>
            </Box>
          )}
          <FormControl variant="outlined">
            <Chip
              className={`chipItem ${
                filter === option.value ? 'Selection' : ''
              }`}
              icon={
                filter === option.value ? (
                  <RiCheckboxCircleFill className="RGChipIcon" />
                ) : (
                  <RiCircleLine className="RGChipIcon" />
                )
              }
              label={option.label}
              name={option.value}
              variant="outlined"
              fullWidth
              onClick={() => handleClick(option.value)}
            />
          </FormControl>
        </React.Fragment>
      ))}
    </StyledRadioGroup>
  );
};

export { RadioGroupFilterV2 };
